import { render, staticRenderFns } from "./calculatepl.vue?vue&type=template&id=5fddcec8"
import script from "./calculatepl.vue?vue&type=script&lang=js"
export * from "./calculatepl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports